
const getters = {
  getResourceFacet: state => facet => state.facets[facet] !== undefined ? JSON.parse(JSON.stringify(state.facets[facet])) : [],
  getCheckedFacets: state => Object.values(state.facets).map((facet) => {
    return facet.filter(({ isChecked }) => isChecked)
  }),
  getResourceCheckedFacet: state => facet => state.facets[facet].filter(({ isChecked }) => isChecked),
  getCurrentFacetFilters: (state) => {
    const currentFilters = {}
    Object.values(state.facets).forEach((facet) => {
      if (facet.filter(({ isChecked }) => isChecked).length > 0) {
        currentFilters[facet[0].facet] = facet.filter(({ isChecked }) => isChecked)
      }
    })
    return currentFilters
  },
  getCurrentRangeFilters: (state) => {
    const currentFilters = {}
    if (state.rangeFilters != null) {
      Object.keys(state.rangeFilters).forEach((key) => {
        currentFilters[key] = { from: state.rangeFilters[key].from, to: state.rangeFilters[key].to }
      })
    }
    return currentFilters
  },
  getFiltersQuery: state => {
    return state.query
  },
  getCheckedFacetsForFilters: state => Object.values(state.facets).map((facet) => {
    return facet.filter(({ isChecked }) => isChecked)
  }).flat().map(({ facet, value }) => {
    if (facet.includes('refinementList=')) {
      facet = facet.split('=')[1]
    }
    return {
      type: facet,
      string: value
    }
  }),
  getSearchQuery: state => state.searchQuery,
  getReferenceQuery: state => state.referenceQuery,
  getOpenedFacets: state => state.facets,
  getCheckedFacetsForFacetAttribute: state => facetAttribute => {
    state.facets[facetAttribute].filter(({ isChecked }) => isChecked)
  },
  getFiltersByAttribute: state => (attribute) => {
    const filter = state.filters[attribute]
    if (filter != null) {
      return state.filters[attribute]
    }
    return null
  },
  getRangeFiltersByAttribute: state => (attribute) => {
    const filter = state.rangeFilters[attribute]
    if (filter != null) {
      return state.rangeFilters[attribute]
    }
    return null
  },
  getAllFilters: state => {
    return state.filters
  },
  getFiltersForSearchQuery: state => {
    let currentFilters = []
    Object.keys(state.filters).forEach((key) => {
      currentFilters.push({
        type: key,
        string: state.filters[key]
      })
    })
    Object.keys(state.facets).forEach((key) => {
      let string = []
      state.facets[key].forEach((facet) => {
        if (facet.isChecked) {
          string.push(facet.value)
        }
      })
      if (string.length > 0) {
        currentFilters.push({
          type: key,
          string
        })
      }
    })
    // const selectedFacets = Object.values(state.facets).map((facet) => {
    //   return facet.filter(({ isChecked }) => isChecked)
    // }).flat()
    // selectedFacets.forEach(({ facet, value }) => {
    //   currentFilters.push({
    //     type: facet,
    //     string: [value]
    //   })
    // })
    return currentFilters
  },
  getRangeFiltersForSearchQuery: state => {
    let currentFilters = []
    Object.keys(state.rangeFilters).forEach((key) => {
      currentFilters.push({
        type: key,
        from: state.rangeFilters[key].from,
        to: state.rangeFilters[key].to
      })
    })
    return currentFilters
  },
  getResourceIndex: state => (state.resourceIndex)
}
export default getters
